// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".commonChanPopPadding[data-v-283e30f6]{padding:10px 20px}", ""]);
// Exports
module.exports = exports;
